module.exports = ".bannera {\n  color: #0000EE;\n  cursor: pointer;\n  text-decoration: none; }\n"